import { useState, useEffect } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import type { IssueDetailsTab } from '.';
import * as IssuesV2Store from '../../../../redux/issuesV2';

/**
 * Handles resetting the tab to the first tab whenever the Drawer is opened.
 *
 * @param {boolean} isDrawerOpen - Whatever is determining if the drawer is open.
 */
function useIssueDetailsTabs(
  isDrawerOpen: boolean,
): [IssueDetailsTab, Dispatch<SetStateAction<IssueDetailsTab>>] {
  const issueId = useSelector(IssuesV2Store.selectors.getActiveIssueId);
  const [activeTab, setActiveTab] = useState<IssueDetailsTab>('issue');

  //  Update the active tab to 'issue' when the drawer opens or the selected issue ID changes.
  //  Note that this only runs once when this prop changes, not the entire time the Drawer is open.
  useEffect(() => {
    if (isDrawerOpen) {
      setActiveTab('issue');
    }
  }, [isDrawerOpen, issueId]);

  return [activeTab, setActiveTab];
}

export default useIssueDetailsTabs;
